














import { VueCustom, CustomVueConstructor } from 'vue-custom';
import { mapGetters } from 'stores';
import { isTextString } from 'helpers/tutorial';

const POSITION_HORIZONTAL = ['left', 'center', 'right'];
const POSITION_VERTICAL = ['top', 'center', 'bottom'];

const getPositionName = (positions: string[], index: number) => {
  if (index > positions.length - 1) return 'center';

  return positions[index];
};

type ComponentCustom = {
  $refs: {
  },
};
export default (VueCustom as CustomVueConstructor<ComponentCustom>).extend({
  name: 'text-tutorials',
  data: (): { textCopy: string, containerClassesCopy: string[] } => ({
    textCopy: '',
    containerClassesCopy: [],
  }),
  computed: {
    ...mapGetters([
      'tutorialTextCurrent',
      'tutorialTextPosition',
    ]),
    classes(): Record<string, boolean> {
      return {
        'js-active': this.tutorialTextCurrent !== null,
      };
    },
    containerClasses(): string[] {
      const position = this.tutorialTextPosition;
      if (!position) return this.containerClassesCopy;

      const classes = [
        `horizontal-${ getPositionName(POSITION_HORIZONTAL, position.horizontal) }`,
        `vertical-${ getPositionName(POSITION_VERTICAL, position.vertical) }`,
      ];
      this.containerClassesCopy = classes;

      return classes;
    },
    text(): string {
      return this.textCopy;
    },
  },
  watch: {
    tutorialTextCurrent(current) {
      if (!current) return;

      let text;
      if (isTextString(current.text)) {
        text = current.text;
      } else {
        text = current.text(this.$store.getters);
      }

      this.textCopy = text;
    },
  },
  methods: {
    hide() {
      this.$store.dispatch('tutorialTextHide');
    },
  },
});
